/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Col_Listing_CodeInputs */

const cs_col_listing_code = /** @type {(inputs: Col_Listing_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Číslo zakázky`)
};

const en_col_listing_code = /** @type {(inputs: Col_Listing_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listing No.`)
};

/**
* | output |
* | --- |
* | "Listing No." |
*
* @param {Col_Listing_CodeInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const col_listing_code = /** @type {((inputs?: Col_Listing_CodeInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Col_Listing_CodeInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_col_listing_code(inputs)
	return cs_col_listing_code(inputs)
});